import axios from 'axios'
import {serverURL} from './config';

const axiosInstance = axios.create({
  baseURL: `${serverURL}/`,
})

export default axiosInstance